export interface cusCompEntity {
  customerCompanyId: string;
  customerName: string;
  customerNo: string;
  customer: {
    customerId: string;
    taxNo: string;
  };
}
export const cusCompEntity_INIT: cusCompEntity = {
  customerCompanyId: "",
  customerName: "",
  customerNo: "",
  customer: {
    customerId: "",
    taxNo: "",
  },
};
export interface CreditLimitEntity {
  temporaryCreditLimitId: string;
  customerCompanyId: string;
  company: string;
  creditLimitRequest: string;
  requestDate: string;
  startDate: string;
  endDate: string;
  remarkRequest: string;
  status: string;
  remarkReject: string;
  userRequest: string;
  isActive: boolean;
  isDeleted: boolean;
  pathFile: string;
  createdBy: string;
  updatedBy: string;
  createdAt: string;
  updatedAt: string;
  customerCompany: cusCompEntity;
}
export const CreditLimitEntity_INIT: CreditLimitEntity = {
  temporaryCreditLimitId: "",
  customerCompanyId: "",
  company: "",
  creditLimitRequest: "",
  requestDate: "",
  startDate: "",
  endDate: "",
  remarkRequest: "",
  status: "",
  remarkReject: "",
  userRequest: "",
  isActive: false,
  isDeleted: false,
  pathFile: "",
  createdBy: "",
  updatedBy: "",
  createdAt: "",
  updatedAt: "",
  customerCompany: cusCompEntity_INIT,
};
export interface AllCreditLimitEntity {
  count: number;
  lastUpdate: string;
  data: CreditLimitEntity[];
}
export const AllCreditLimitEntity_INIT: AllCreditLimitEntity = {
  count: 0,
  lastUpdate: "",
  data: [CreditLimitEntity_INIT],
};
export interface ShopDetailEntity {
  customerCompanyId: string;
  customerId: string;
  customerName: string;
  customerNo: string;
  zone: string;
  creditLimit: number;
  pdcCollect: string;
  outstanding: string;
  arBalance: string;
  creditLimitBalance: string;
  province?: string;
  telephone: string;
  taxNo: string;
  ownerFirstname: string;
  ownerLastname: string;
  creditLimitPercent: number;
  overCredit: string;
  orderOverCredit: string;
  overCreditPercent: string;
  creditLimitBalancePercent: number;
  arBalancePercent: number;
  pdcCollectPercent: number;
  outstandingPercent: number;
  pending: number;
  pendingPercent: number;
}
export const ShopDetailEntity_INIT: ShopDetailEntity = {
  customerCompanyId: "",
  customerId: "",
  customerName: "",
  customerNo: "",
  zone: "",
  creditLimit: 0,
  pdcCollect: "",
  outstanding: "",
  arBalance: "",
  creditLimitBalance: "",
  province: "",
  telephone: "",
  taxNo: "",
  ownerFirstname: "",
  ownerLastname: "",
  creditLimitPercent: 0,
  overCredit: "",
  orderOverCredit: "",
  overCreditPercent: "",
  creditLimitBalancePercent: 0,
  arBalancePercent: 0,
  pdcCollectPercent: 0,
  outstandingPercent: 0,
  pending: 0,
  pendingPercent: 0,
};
export interface HistoryCreditLimitEntity {
  action: string;
  afterValue: string;
  beforeValue: string;
  createdAt: string;
  createdBy: string;
  isActive: boolean;
  reason: string;
  temporaryCreditLimitHistoryId: string;
  temporaryCreditLimitId: string;
}
export const HistoryCreditLimitEntity_INIT: HistoryCreditLimitEntity = {
  action: "",
  afterValue: "",
  beforeValue: "",
  createdAt: "",
  createdBy: "",
  isActive: false,
  reason: "",
  temporaryCreditLimitHistoryId: "",
  temporaryCreditLimitId: "",
};
export interface ShopCreditLimitEntity {
  customerCompanyId: string;
  customerId: string;
  customerName: string;
  customerNo: string;
  zone: string;
  creditLimit: number;
  updateDate: string;
  province: string;
  taxNo: string;
  creditUsed: number;
  overCredit: number;
  perCentCreditUsed: number;
  creditBalance: number;
  percentCreditBalance: number;
}
export const ShopCreditLimitEntity_INIT: ShopCreditLimitEntity = {
  customerCompanyId: "",
  customerId: "",
  customerName: "",
  customerNo: "",
  zone: "",
  creditLimit: 0,
  updateDate: "",
  province: "",
  taxNo: "",
  creditUsed: 0,
  overCredit: 0,
  perCentCreditUsed: 0,
  creditBalance: 0,
  percentCreditBalance: 0,
};
export interface AllShopCreditLimitEntity {
  count: number;
  lastUpdate: string;
  data: ShopCreditLimitEntity[];
}
export const AllShopCreditLimitEntity_INIT: AllShopCreditLimitEntity = {
  count: 0,
  lastUpdate: "",
  data: [ShopCreditLimitEntity_INIT],
};
